module.exports = __webpack_public_path__ + "img/3.3a0a2765.jpg";